module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.574fd0b5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/Roboto-Medium.woff2
// module id = 1825
// module chunks = 0